import {
  PERMISSIONS_REQUEST, PERMISSIONS_SET, PERMISSIONS_SET_ALL_CHECKED, PERMISSIONS_SET_SEARCH_TEXT, PERMISSIONS_SUCCESS,
  PERMISSIONS_UPDATE_REQUEST, PERMISSIONS_UPDATE_SUCCESS,
} from '../constants/actionTypes';
import {getApiConfig} from '../utilities';
import * as actions from "./A_Popups";


const rights = getApiConfig('Users/UpdateEntityAccessRights');
const areas = getApiConfig('Users/GetProtectedAreas');

export const getPermissions = (entityId, entityType, fabricatorId = null) => {
  const {get} = getApiConfig(`Users/GetEntityAccessRights/${entityId}/${entityType}/${fabricatorId}`);

  return dispatch => {
    dispatch(actions.loadingDialog_show(true, 'Loading...', 'Please wait while permissions are loaded.'));
    dispatch(getPermissionsRequest());

    Promise.all([
      get(),
      areas.post({})
    ])
      .then(([userRights, allRights]) => {
        dispatch(getPermissionsSuccess({
          userRights,
          allRights: allRights.rows
        }));
        dispatch(actions.loadingDialog_show(false));
      })
  }
};

export const updatePermissions = (permissions) => {
  return dispatch => {
    dispatch(actions.loadingDialog_show(true, 'Saving...', 'Saving permissions, this will take just a moment.'));
    dispatch(updatePermissionsRequest());

    rights.post(permissions)
      .then((userRights) => {
        dispatch(updatePermissionsSuccess({
          userRights
        }));
        dispatch(actions.loadingDialog_show(false));
      })
  }
};

export const getPermissionsRequest = () => {
  return {
    type: PERMISSIONS_REQUEST
  }
};

export const getPermissionsSuccess = (permissions) => {
  return {
    type: PERMISSIONS_SUCCESS,
    permissions
  }
};

export const setPermissions = (permissions) => ({
  type: PERMISSIONS_SET,
  permissions
});

export const updatePermissionsRequest = () => {
  return {
    type: PERMISSIONS_UPDATE_REQUEST
  }
};

export const updatePermissionsSuccess = (permissions) => {
  return {
    type: PERMISSIONS_UPDATE_SUCCESS,
    permissions
  }
};

export const setAllChecked = (allChecked) => ({
  type: PERMISSIONS_SET_ALL_CHECKED,
  payload: { allChecked }
});

export const setSearchInputValue = (searchText) => ({
  type: PERMISSIONS_SET_SEARCH_TEXT,
  payload: { searchText }
});
